import { useState } from 'react';
import { Button, Typography } from '@screentone/core';

import { ScheduleDialog } from 'components/schedule-dialog/ScheduleDialog';
import { PublicationSetting } from 'data/generated/graphql';

export const NewsletterScheduleDialog = ({
  handleSchedule,
  reschedule = false,
  publicationSetting,
  latestEmbargoTimestamp,
  hasEmbargo = false
}: {
  handleSchedule: (publishUtc: number) => void;
  reschedule?: boolean;
  publicationSetting?: PublicationSetting;
  latestEmbargoTimestamp?: number;
  hasEmbargo?: boolean;
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  let afterCalendarContent = publicationSetting ? (
    <Typography variant="note">
      All times are in {publicationSetting.preferredTimezone.timezoneAbbreviation}.
    </Typography>
  ) : null;

  const handleScheduleClick = (publishUtc: number) => {
    handleSchedule(publishUtc);
    setModalOpen(false);
  };

  if (hasEmbargo && publicationSetting) {
    afterCalendarContent = (
      <Typography variant="note">
        All times are in {publicationSetting.preferredTimezone.timezoneAbbreviation}. This newsletter is required to be
        sent at least 5 minutes after the embargo has been lifted.
      </Typography>
    );
  }

  return (
    <>
      <Button primary onClick={() => setModalOpen(true)} data-testid="newsletters-schedule-button">
        {reschedule ? 'Reschedule' : 'Schedule'}
      </Button>
      {modalOpen && (
        <ScheduleDialog
          dialogTitle="Schedule Newsletter"
          onSchedule={handleScheduleClick}
          onCancel={() => setModalOpen(false)}
          afterCalendarContent={afterCalendarContent}
          publicationSetting={publicationSetting}
          latestEmbargoTimestamp={latestEmbargoTimestamp}
          hasEmbargo={hasEmbargo}
        />
      )}
    </>
  );
};
